import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Target, RefreshCw } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-4 bg-navy-800 relative overflow-hidden" data-id="element-134">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-orange/5 to-transparent pointer-events-none" data-id="element-135"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-137">
          <div className="inline-flex items-center space-x-2 bg-brand-orange/10 text-brand-light px-4 py-2 rounded-full mb-6 font-semibold border border-brand-orange/20" data-id="element-138">
            <Zap className="w-5 h-5" data-id="element-139" />
            <span data-id="element-140">EL MECANISMO ÚNICO</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-white" data-id="element-141">
            Sincronización de Pulso Insulínico
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-142">
            Este método no se basa en la restricción, sino en la precisión. En
            lugar de luchar contra tu cuerpo, aprendes a enviar las señales
            correctas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-144">
            <div className="flex items-start space-x-4" data-id="element-145">
              <div className="bg-navy-900 p-3 rounded-lg border border-navy-700 mt-1" data-id="element-146">
                <Target className="w-6 h-6 text-brand-orange" data-id="element-147" />
              </div>
              <div data-id="element-148">
                <h3 className="text-xl font-bold mb-2" data-id="element-149">
                  Quema de Grasa Dirigida
                </h3>
                <p className="text-gray-400" data-id="element-150">
                  Tu hígado vacía sus depósitos de azúcar y empieza a consumir
                  la grasa de la cintura como fuente de energía principal.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4" data-id="element-151">
              <div className="bg-navy-900 p-3 rounded-lg border border-navy-700 mt-1" data-id="element-152">
                <RefreshCw className="w-6 h-6 text-brand-orange" data-id="element-153" />
              </div>
              <div data-id="element-154">
                <h3 className="text-xl font-bold mb-2" data-id="element-155">Reinicio Biológico</h3>
                <p className="text-gray-400" data-id="element-156">
                  Un sistema diseñado específicamente para la fisiología
                  masculina senior, respetando tus cambios hormonales.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-900 p-8 rounded-2xl border border-brand-orange/30 shadow-[0_0_40px_rgba(232,130,12,0.1)]" data-id="element-157">
            <h4 className="text-2xl font-bold mb-6 text-center border-b border-navy-700 pb-4" data-id="element-158">
              El Cambio de Paradigma
            </h4>
            <div className="space-y-6" data-id="element-159">
              <div className="flex justify-between items-center text-gray-400" data-id="element-160">
                <span data-id="element-161">Enfoque Tradicional</span>
                <span className="text-red-400 font-semibold" data-id="element-162">Restricción</span>
              </div>
              <div className="w-full h-px bg-navy-700" data-id="element-163"></div>
              <div className="flex justify-between items-center text-white text-lg" data-id="element-164">
                <span className="font-bold" data-id="element-165">Código 55+</span>
                <span className="text-brand-light font-bold" data-id="element-166">
                  Precisión Hormonal
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}